import { Currency } from '@vierkant-software/types__api';
import { BaseConfig } from '../../modules/wrappers/lib/config.interface';

interface ICashRegisterBalanceConfig {
  currency?: Currency;
}

export class CashRegisterBalanceConfig extends BaseConfig<ICashRegisterBalanceConfig> implements ICashRegisterBalanceConfig {
  /**
   * Currency of the cash register.
   * @values 'EUR' | 'CHF'
   */
  currency?: Currency;

  /**
   * @theme Base
   */
  static baseTheme = {
    /**
     * Default configuration.
     * Currency is "EUR".
     */
    Default: new CashRegisterBalanceConfig({
      currency: Currency.EUR,
    }),

    /**
     * Currency is "EUR".
     */
    EUR: new CashRegisterBalanceConfig({
      currency: Currency.EUR,
    }),

    /**
     * Currency is "CHF".
     */
    CHF: new CashRegisterBalanceConfig({
      currency: Currency.CHF,
    }),
  };
}
